import type { Scope, VenueGroup, VenueGroupItem, CreateVenueGroupPayload, EditVenueGroupPayload } from './types';
import merchantGatewayApi from '../merchant-gateway/api';

export const MERCHANT_ENTERPRISE_SERVICE = '/merchant-enterprise-service/public/v1';

export const fetchVenueGroups = async (scope: Scope): Promise<VenueGroupItem[]> => {
  const params = new URLSearchParams();
  params.append('scopeType', scope.type);
  params.append('scopeId', scope.id);

  const response = await merchantGatewayApi.get(`${MERCHANT_ENTERPRISE_SERVICE}/venue-groups?${params.toString()}`);
  return response.data;
};

export const createVenueGroup = async (scope: Scope, params: CreateVenueGroupPayload): Promise<VenueGroup> => {
  const response = await merchantGatewayApi.post(`${MERCHANT_ENTERPRISE_SERVICE}/venue-groups`, {
    ...params,
    scope,
  });
  return response.data;
};

export const addVenuesToVenueGroup = async (venueGroupId: string, venueIds: string[]): Promise<VenueGroupItem> => {
  const response = await merchantGatewayApi.post(`${MERCHANT_ENTERPRISE_SERVICE}/venue-groups/${venueGroupId}/venues`, {
    venueIds,
  });
  return response.data;
};

export const deleteVenueGroup = async (venueGroupId: string) => {
  const response = await merchantGatewayApi.delete(`${MERCHANT_ENTERPRISE_SERVICE}/venue-groups/${venueGroupId}`);
  return response.data;
};

export const updateVenueGroup = async (venueGroupId: string, params: EditVenueGroupPayload): Promise<VenueGroup> => {
  const response = await merchantGatewayApi.put(`${MERCHANT_ENTERPRISE_SERVICE}/venue-groups/${venueGroupId}`, params);
  return response.data;
};

export const fetchDetailVenueGroup = async (venueGroupId: string): Promise<VenueGroupItem> => {
  const response = await merchantGatewayApi.get(`${MERCHANT_ENTERPRISE_SERVICE}/venue-groups/${venueGroupId}`);
  return response.data;
};

export const removeVenueFromVenueGroup = async (venueGroupId: string, venueId: string): Promise<VenueGroupItem> => {
  const response = await merchantGatewayApi.delete(
    `${MERCHANT_ENTERPRISE_SERVICE}/venue-groups/${venueGroupId}/venues/${venueId}`,
  );
  return response.data;
};
